export default "__VITE_ASSET__CYb_23aw__"